import React from "react";
import { Chip } from "@mui/material";
import { OrderStatus } from "../data/types";

const STYLES: Record<OrderStatus, { bg: string; fg: string }> = {
  New:       { bg: "#e8f0fe", fg: "#1a56c4" },
  Pending:   { bg: "#fdf0d5", fg: "#b26a00" },
  Confirmed: { bg: "#e7f3ec", fg: "#1f7a4d" },
  Preparing: { bg: "#efe7fb", fg: "#6a3fb0" },
  Delivered: { bg: "#e7f3ec", fg: "#2e9e5b" },
  Cancelled: { bg: "#fde8e8", fg: "#c0392b" },
};

const StatusChip: React.FC<{ status: OrderStatus }> = ({ status }) => {
  const s = STYLES[status] ?? STYLES.New;
  return (
    <Chip
      label={status} size="small"
      sx={{ bgcolor: s.bg, color: s.fg, fontWeight: 600, borderRadius: 1 }}
    />
  );
};

export default StatusChip;
